﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const beneAPI = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/InsuranceServices`,
  scopes: ExtHubRequest,
});

beneAPI.createEntities([
  { name: 'getBeneficiaryInformation' },
  { name: 'saveBeneficiaryRequest' },
  { name: 'sendBeneMailing' },
  { name: 'InsertClaimsFormRequest' },
]);

const GetBeneficiaryInformation = (body) => beneAPI.endpoints.getBeneficiaryInformation.post(body);
const SaveBeneficiaryRequest = (body) => beneAPI.endpoints.saveBeneficiaryRequest.post(body);
const SendBeneMailing = (body) => beneAPI.endpoints.sendBeneMailing.post(body);
const InsertClaimsFormRequest = (body) => beneAPI.endpoints.InsertClaimsFormRequest.post(body);

export {
  GetBeneficiaryInformation,
  SaveBeneficiaryRequest,
  SendBeneMailing,
  InsertClaimsFormRequest,
};
